<div class="dimension-navigation-tabs">
  <m-tab-view
    [(activeIndex)]="activeIndex"
    [tabPanelHeaders]="tabPanelHeaders"
    (activeIndexChange)="tabChange($event)">
  </m-tab-view>
</div>
